import { nextTick } from 'vue'

const FOCUSABLE_ELEMENTS = 'input, select, textarea'

const autofocus = {
  mounted: (el: HTMLElement) => {
    nextTick(() => {
      if (el.matches(FOCUSABLE_ELEMENTS)) {
        el.focus()
      } else {
        el.querySelector<HTMLElement>(FOCUSABLE_ELEMENTS)?.focus()
      }
    })
  },
}

export default autofocus
